import React from "react";
import "./timeline.css";
import { motion } from "framer-motion";

const items = [
];

export default function Timeline() {
  return (
    <section id="journey" className="timeline">
      <div className="tl-wrapper">
        {items.map(({year,title,place,side},i)=>(
          <motion.div
            className={`tl-item ${side}`}
            key={i}
            whileInView={{opacity:1,y:0}}
            initial={{opacity:0,y:40}}
            transition={{duration:0.6,delay:i*0.15}}
          >
            <span className="tl-year">{year}</span>
            <h3>{title}</h3><p>{place}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}